// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2K8Bf","productName":"Table_productName__32tJT"};